const ExportToExcel = (fileName, data, options) => {
  const wb = window.XLSX.utils.book_new();
  const ws = window.XLSX.utils.json_to_sheet(data, options)
  wb.SheetNames.push('Hoja 1')
  wb.Sheets['Hoja 1'] = ws
  return window.XLSX.writeFile(wb, fileName + '.xlsx')
}

export default ExportToExcel
